import type {BranchPageAvailabilityKey} from '#shared/types/branchAvailability';

type BranchSelectorAvailabilityRequirement = {
	key: BranchPageAvailabilityKey;
	disabledText: string;
};

export default function useBranchSelectorAvailabilityRequirement() {
	const route = useRoute();

	const requirement = computed<BranchSelectorAvailabilityRequirement | null>(() => {
		const routeName = typeof route.name === 'string' ? route.name : '';

		if (!routeName.startsWith('branch-')) {
			return null;
		}

		if (routeName.startsWith('branch-online-objednavka')) {
			return {
				key: 'hasOnlineOrder',
				disabledText: 'Pobočka nemá tuto možnost',
			};
		}

		if (routeName === 'branch-letaky' || routeName.startsWith('branch-letaky-')) {
			return {
				key: 'hasLeaflets',
				disabledText: 'Pobočka nemá tuto možnost',
			};
		}

		if (routeName === 'branch-sluzby-restaurace' || routeName.startsWith('branch-sluzby-restaurace-')) {
			return {
				key: 'hasRestaurant',
				disabledText: 'Pobočka nemá tuto možnost',
			};
		}

		if (routeName === 'branch-sluzby' || routeName.startsWith('branch-sluzby-')) {
			return {
				key: 'hasServices',
				disabledText: 'Pobočka nemá tuto možnost',
			};
		}

		return null;
	});

	return {requirement: readonly(requirement)};
}
